import { useGetNfts } from './useGetNfts';

interface Props {
    search?: string;
}

interface CollectionEntry {
    collection_name: string;
    collection_slug: string;
    collection_image: string;
    asset_count: number;
}

export const useGetCollectionsData = ({ search }: Props) => {
    const { data } = useGetNfts();
    const nftEntries = data?.pages?.flatMap((page) => page.data);

    const collections = nftEntries?.reduce<CollectionEntry[]>((acc, entry) => {
        const collectionName = entry?.content?.collection_name;

        if (collectionName) {
            const collection = acc.find((c) => c.collection_name === collectionName);
            if (collection) {
                collection.asset_count++;
            } else {
                acc.push({
                    collection_name: entry?.content?.collection_name || '',
                    collection_slug: entry?.content?.slug || '',
                    collection_image: entry?.content?.collection_image || '',
                    asset_count: 1,
                });
            }
        }
        return acc;
    }, []);

    const filteredCollections = search
        ? collections?.filter((collection) => collection.collection_name.toLowerCase().includes(search.toLowerCase()))
        : collections;

    const collections_count = collections ? collections.length : undefined;

    return { collections: filteredCollections, collections_count };
};
